'use strict';

var $ = require('js/sw-jquery/sw-jquery');
var SliderView = require('js/lib/views/SliderView');

 module.exports = function($fragment) {

  $fragment.swFindWithSelf(SliderView.prototype.swSelectors.ROOT).each(function() {
    
    var $el = $(this);

    new SliderView({
    	el: $el
    });
  });

};
